import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4382 2.29639C12.2482 1.95101 11.7519 1.95101 11.5619 2.29639L1.40757 20.7589C1.2243 21.0921 1.46538 21.4998 1.84568 21.4998H22.1544C22.5347 21.4998 22.7758 21.0921 22.5925 20.7589L12.4382 2.29639ZM11.2614 16V8H12.7614V16H11.2614ZM12.75 18.249C12.75 18.6627 12.4142 18.998 12 18.998C11.5858 18.998 11.25 18.6627 11.25 18.249C11.25 17.8353 11.5858 17.5 12 17.5C12.4142 17.5 12.75 17.8353 12.75 18.249Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }